import { parseJSON } from 'date-fns';
import constants from '../constants/constants';
import * as jobService from "../services/service/jobService";

var moment = require('moment');

export function getInputClasses(formik, fieldname) {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
        return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
        return "is-valid";
    }

    return "";
};

export function convertJsonToFormData(json) {
    var form_data = new FormData();
    for (var key in json) {
        if (Array.isArray(json[key]))
            json[key].forEach(item => form_data.append(key, item));
        else
            form_data.append(key, (json[key] === null) ? "" : json[key]);
    }

    return form_data;
};

export function setToOptionModel(name, value) {
    return { label: name, value: value }
}

export function getFullStateName(abbr) {
    return constants.US_STATES[abbr] ? constants.US_STATES[abbr] : abbr;
}

export function formatToUSDate(date) {
    var momentDate = moment(date);

    return (momentDate.isValid()) ? momentDate.format("MM/DD/yyyy") : null;
}

export function getDateDifferenceInDays(firstDate, secondDate) {
    return moment(firstDate).diff(secondDate ? moment(secondDate) : moment(), "days");
}

export function dashIfNull(value) {
    return value ? value : "-";
}

export function getCredentialBadgeColor(expiryDate) {
    let daysRemaining = getDateDifferenceInDays(expiryDate);

    if (daysRemaining === 0) {
        return ["EXPIRES TODAY", "bg-yellow"];
    }

    if (daysRemaining < 0) {
        return ["EXPIRED", "bg-red"];
    } else if (daysRemaining <= 7) {
        return ["EXPIRING", "bg-yellow"];
    }

    return ["ACTIVE", "bg-green"];
}

export function getCredentialExpiresInColor(expiryDate) {
    let daysRemaining = getDateDifferenceInDays(expiryDate);
    if (daysRemaining < 0) {
        return ["Expired", "", "bg-red"];
    }
    if (daysRemaining === 0) {
        return ["Today", "", "bg-yellow"];
    }
    if (daysRemaining <= 90) {
        return [daysRemaining, "Days", daysRemaining <= 7 ? "bg-yellow" : "bg-green"];
    } else if (daysRemaining > 90 && daysRemaining <= 365) {
        let monthsRemaining = moment(expiryDate).diff(moment(), "months");
        monthsRemaining += daysRemaining % 30 > 0 ? " +" : "";

        return [monthsRemaining, "Months", "bg-green"];
    } else if (daysRemaining > 365) {
        let yearsRemaining = moment(expiryDate).diff(moment(), "years");
        yearsRemaining += daysRemaining % 365 > 0 ? " +" : "";

        return [yearsRemaining, "Years", "bg-green"];
    }
}

export function dateFilterLogic(date, filters) {
    var check = new Date(date);
    var from = new Date(filters[0]);
    var to = new Date(filters[1]);
    from.setDate(from.getDate() + 1);
    to.setDate(to.getDate() + 1);
    from = new Date(from).setHours(0, 0, 0, 0);
    to = new Date(to).setHours(23, 59, 59, 59);

    if (filters[0] && filters[1] && check >= to && check <= from) {
        return true;
    } else if (filters[0] && check >= to) {
        return true;
    } else if (filters[1] && check <= from) {
        return true;
    }
    return false;
}

export function dateFilterListRenderer(v) {
    if (v[0] && v[1]) {
        return `Start Date: ${v[0]} to End Date: ${v[1]}`;
    } else if (v[0]) {
        return `Start Date: ${v[0]}`;
    } else if (v[1]) {
        return `End Date: ${v[1]}`;
    }
    return false;
}

export function getJSONFromLocalStorage(key) {
    var savedObj = localStorage.getItem(key);

    return savedObj ? JSON.parse(savedObj) : savedObj;
}

export function saveJSONToLocalStorage(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj));
}

export function reOrderDnd(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result.map((x, i) => { return { ...x, sortOrder: i } });;
};

export function getItemStyleDnd(isDragging, draggableStyle) {
    return ({
        userSelect: 'none',
        padding: 8 * 2,
        margin: `0 0 8px 0`,
        background: isDragging ? '#e3fcef' : 'rgb(255, 255, 255)',
        borderRadius: isDragging ? '2px' : '0px',
        border: isDragging ? '2px solid rgba(9, 30, 66, 0.71)' : '0',
        boxShadow: isDragging ? 'rgb(165 173 186) 2px 2px 1px' : 'none',
        ...draggableStyle
    });
}

export function getListStyleDnd(isDraggingOver) {
    return ({
        background: isDraggingOver ? 'rgb(255, 235, 230)' : '#ebecf0',
        padding: 8,
    });
}

export function calculateWorkingDays(startDate, endDate) {
    if (startDate && endDate) {
        let difference = moment.duration(moment(endDate).diff(moment(startDate))).asDays();

        if (difference > 0) {
            return jobService.getWeekDayDifferenceBetweenTwoDates(startDate, endDate);
        }

        return new Promise((resolve, reject) => {
            return reject(0)
        });
    }

    return new Promise((resolve, reject) => {
        return reject(0)
    });
}

export function getRoutesForForm(formName) {
    let route = "/forms/"
    if (formName.includes("Project Information Sheet")) {
        return route += 'project-info-sheet/';
    }
    if (formName.includes("Lead Information Sheet")) {
        return route += 'lead-info-sheet/';
    }
    if (formName.includes("Employee Acknowledgement Form")) {
        return route += 'employee-acknowledgement-form/';
    }
    if (formName.includes("LeadAirWorker Acknowledgement Form")) {
        return route += 'leadAirWorker-acknowledgement-form/';
    }

    switch (formName) {
        case "HA PLM Data Sheet":
            route += 'plm-data-sheet/';
            break;
        // case "HA PLM Data Sheet":
        //     route += 'ha-plm-data-sheet/';
        //     break;
        case "Daily Log Form":
            route += 'daily-log-form/';
            break;
        case "Project Information Sheet":
            route += 'project-info-sheet/';
            break;
        case "PCM-Air Data Sheet":
            route += 'pcm-data-sheet/';
            break;
        case "PCM Chain Of Custody":
            route += 'pcm-coc/';
            break;
        case "Lead-Air Data Sheet":
            route += 'lead-air-data-sheet/';
            break;
        case "Lead-Air Chain Of Custody":
            route += 'lead-air-coc/';
            break;
        case "Lead-Paint Chip Data Sheet":
            route += 'lead-paint-data-sheet/';
            break;
        case "Lead-Paint Chain Of Custody":
            route += 'lead-paint-coc/';
            break;
        case "Lead-TCLP Data Sheet":
            route += 'lead-tclp-data-sheet/';
            break;
        case "Lead-TCLP Chain Of Custody":
            route += 'lead-tclp-coc/';
            break;
        case "PLM Chain Of Custody":
            route += 'plm-coc/';
            break;
        case "ACM Log Form":
            route += 'acm-plm-log/';
            break;
        default:
            break;
    }

    return route;
}

export function getGeoLocationError(error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            return "User denied the request for Geolocation."
        case error.POSITION_UNAVAILABLE:
            return "Location information is unavailable."
        case error.TIMEOUT:
            return "The request to get user location timed out."
        case error.UNKNOWN_ERROR:
            return "An unknown error occurred."
    }
}